// API response types (from Cloudflare D1 via db-api)
export interface ApiRoomData {
  id: number
  roomSlug: string
  roomName: string
  creatorUsername: string
  creatorDid: string
  createdAt: string
  flair?: string
  participant_count?: number
}

// Frontend types
export interface Room {
  id: string
  name: string
  uniqueId: string
  createdBy: string
  createdByDid: string
  createdAt: string
  participants: string[]
  participantCount: number
  tags?: string[] // Room tags like "Everyone welcome", "Cam & mic required"
}

// Conversion utility
export function adaptApiRoomToFrontend(apiRoom: ApiRoomData): Room {
  // Convert flair to tags array, but only if it's not "No flair"
  // Flair can be comma-separated for multiple flairs
  const tags: string[] = []
  if (apiRoom.flair && apiRoom.flair !== 'No flair') {
    // Split by comma in case of multiple flairs
    const flairItems = apiRoom.flair.split(',').map(f => f.trim())
    tags.push(...flairItems)
  }

  return {
    id: apiRoom.roomSlug, // Use the slug as the ID for URLs
    name: apiRoom.roomName,
    uniqueId: apiRoom.roomSlug, // Use the slug as the unique identifier
    createdBy: apiRoom.creatorUsername,
    createdByDid: apiRoom.creatorDid,
    createdAt: apiRoom.createdAt,
    participants: [apiRoom.creatorUsername], // Will be updated when we have real participant tracking
    participantCount: apiRoom.participant_count ?? 0,
    tags: tags, // Real tags from backend flair data (can be multiple)
  }
}
